// ** Initial State
const initialState = {
    langKeys :{}
}

export const store_langKeys = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_LANG_KEYS':
            return { ...state, langKeys: action.langKeys }
        default:
            return state
    }
}

// export default store_langKeys
